import {
    ADD_ADDRESS as SourceADD_ADDRESS,
    ADDRESS_POPUP_ID as SourceADDRESS_POPUP_ID,
    DELETE_ADDRESS as SourceDELETE_ADDRESS,
    EDIT_ADDRESS as SourceEDIT_ADDRESS
} from 'SourceComponent/MyAccountAddressPopup/MyAccountAddressPopup.config';

// TODO: implement ADDRESS_POPUP_ID
export const ADDRESS_POPUP_ID = SourceADDRESS_POPUP_ID;

// TODO: implement EDIT_ADDRESS
export const EDIT_ADDRESS = SourceEDIT_ADDRESS;

// TODO: implement DELETE_ADDRESS
export const DELETE_ADDRESS = SourceDELETE_ADDRESS;

// TODO: implement ADD_ADDRESS
export const ADD_ADDRESS = SourceADD_ADDRESS;
